var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.initialized,
          expression: "initialized"
        }
      ]
    },
    [
      _c("div", { staticClass: "hearing-aid-sales__filters" }, [
        _c(
          "div",
          { staticClass: "filter-sales-dates__from-date filter-selection" },
          [
            _c("div", { staticClass: "filter-selection__title" }, [
              _vm._v("From:")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-selection__body" },
              [
                _c("StoreConnectedDatePicker", {
                  staticClass:
                    "filter-selection__select filter-selection__select--date",
                  attrs: {
                    store: _vm.store,
                    name: "dateFrom",
                    placeholder: "From",
                    format: "MMM yyyy",
                    "disabled-dates": _vm.disabledRangeFrom,
                    "minimum-view": "month"
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filter-sales-dates__to-date filter-selection" },
          [
            _c("div", { staticClass: "filter-selection__title" }, [
              _vm._v("To:")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-selection__body" },
              [
                _c("StoreConnectedDatePicker", {
                  staticClass:
                    "filter-selection__select filter-selection__select--date",
                  attrs: {
                    store: _vm.store,
                    name: "dateTo",
                    placeholder: "To",
                    format: "MMM yyyy",
                    "disabled-dates": _vm.disabledRangeTo,
                    "minimum-view": "month"
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "filter-products__vendor filter-selection" }, [
          _c("div", { staticClass: "filter-selection__title" }, [
            _vm._v("Vendor:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-selection__body" },
            [
              _c("StoreConnectedSelect", {
                staticClass: "filter-selection__select",
                attrs: {
                  store: _vm.store,
                  action: _vm.action,
                  name: _vm.name,
                  "sub-prop": "vendor",
                  placeholder: "Vendors",
                  options: _vm.vendorsList,
                  multiple: "",
                  "clear-button": ""
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-products__tier filter-selection" }, [
          _c("div", { staticClass: "filter-selection__title" }, [
            _vm._v("Tier:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-selection__body" },
            [
              _c("StoreConnectedSelect", {
                staticClass: "filter-selection__select",
                attrs: {
                  store: _vm.store,
                  action: _vm.action,
                  name: _vm.name,
                  "sub-prop": "tier",
                  placeholder: "Tiers",
                  options: _vm.tiersList,
                  multiple: "",
                  "clear-button": ""
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filter-products__product filter-selection" },
          [
            _c("div", { staticClass: "filter-selection__title" }, [
              _vm._v("Product:")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-selection__body" },
              [
                _c("StoreConnectedSelect", {
                  staticClass: "filter-selection__select",
                  attrs: {
                    store: _vm.store,
                    action: _vm.action,
                    name: _vm.name,
                    "sub-prop": "product",
                    placeholder: "Products",
                    "options-label": "product",
                    "options-value": "product",
                    options: _vm.productsList,
                    multiple: "",
                    "clear-button": "",
                    search: ""
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "hearing-aid-sales__commands" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-primary hearing-aid-sales__btn-run",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.update($event)
                  }
                }
              },
              [_vm._v("Run Report")]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }